// Extracted from FileInput/CropModal.tsx (previously private to that file)
// so ImageInsertDialog (admin's ai-case-editor) can reuse the same canvas
// crop math without depending on CropModal's FileWithPreview/addFile props,
// which are shaped for the generic file-upload flow, not a document editor's
// insert dialog.
export interface ICropArea {
  x: number;
  y: number;
  width: number;
  height: number;
}

const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) =>
      reject(error as unknown as Error),
    );
    image.setAttribute("crossOrigin", "anonymous"); // Needed for canvas Tainted check
    image.src = url;
  });

// `mimeType` defaults to JPEG — CropModal's existing callers pass none and
// keep that behaviour. Pass "image/png" to preserve transparency; anything
// else canvas doesn't support falls back to the browser's own default (JPEG
// in every current engine).
export async function getCroppedImg(
  imageSrc: string,
  pixelCrop: ICropArea,
  outputWidth: number = pixelCrop.width,
  outputHeight: number = pixelCrop.height,
  mimeType = "image/jpeg",
): Promise<Blob | null> {
  try {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return null;
    }

    canvas.width = outputWidth;
    canvas.height = outputHeight;

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      outputWidth,
      outputHeight,
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), mimeType);
    });
  } catch (error) {
    console.error("Error in getCroppedImg:", error);
    return null;
  }
}
